var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRichTextField(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_143_16145)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.37256 3.63379C2.37256 2.8041 3.04287 2.13379 3.87256 2.13379H12.8726H21.8726C22.7022 2.13379 23.3726 2.8041 23.3726 3.63379V6.63379C23.3726 7.46348 22.7022 8.13379 21.8726 8.13379C21.0429 8.13379 20.3726 7.46348 20.3726 6.63379V5.13379H14.3726V20.1338H16.6226C17.4522 20.1338 18.1226 20.8041 18.1226 21.6338C18.1226 22.4635 17.4522 23.1338 16.6226 23.1338H9.12256C8.29287 23.1338 7.62256 22.4635 7.62256 21.6338C7.62256 20.8041 8.29287 20.1338 9.12256 20.1338H11.3726V5.13379H5.37256V6.63379C5.37256 7.46348 4.70225 8.13379 3.87256 8.13379C3.04287 8.13379 2.37256 7.46348 2.37256 6.63379V3.63379Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_143_16145"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 24,
    fill: "white",
    transform: "translate(2.37256 0.633789)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRichTextField);
export default __webpack_public_path__ + "static/media/rich-text-field.b463872448700f01513f5b2cecc2912d.svg";
export { ForwardRef as ReactComponent };